const hasPlainPrototype = (test: any) => {
  const proto = Object.getPrototypeOf(test);

  return proto === Object.prototype || proto === null || proto === undefined;
};
const isPlainObject = (test: any) =>
  typeof test === 'object' && test !== null && hasPlainPrototype(test);

export { isPlainObject };
